import { render } from "./SignerRoomSALazyLoad.vue?vue&type=template&id=f0022848&scoped=true"
import script from "./SignerRoomSALazyLoad.vue?vue&type=script&lang=js"
export * from "./SignerRoomSALazyLoad.vue?vue&type=script&lang=js"

import "./SignerRoomSALazyLoad.vue?vue&type=style&index=0&id=f0022848&lang=css"
import "./SignerRoomSALazyLoad.vue?vue&type=style&index=1&id=f0022848&scoped=true&lang=css"
import "./SignerRoomSALazyLoad.vue?vue&type=style&index=2&id=f0022848&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0022848"]])

export default __exports__